import './loading-circle.css';

export function LoadingCircle({
  className,
  duration = 5000,
}: {
  className?: string;
  duration?: number;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="text-white"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle
        className="origin-center -rotate-90 text-indigo-700"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="62.83"
        style={{
          animation: `loadingSpin ${duration / 1000}s linear infinite`,
        }}
      />
    </svg>
  );
}
